(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["verifyAuthenticity"] && !Shopify.designMode) return;
  try {
    

var signData;
var lookupNumber = "";

var lookupInput = document.getElementById("lookupNumber");
var submitBtn = document.getElementById("submitLook");
var loadWaiter = document.getElementById("loadwaiter");
var errorBox = document.getElementById("vaError");
var successBox = document.getElementById("vaSuccess");

async function getData() {
  // Same Google Sheet endpoint as before - do not change without updating the sheet too.
  let response = await fetch('https://sheets.googleapis.com/v4/spreadsheets/1YUL9mof5yffiqmm6yDPgS7xKplfX-iiP23Zhu8cppvU/values/Database?key=AIzaSyAnyrAVBZ4QZ1BgPELaOTTGIYUlqta3tbo');
  let data = await response.json();
  return data;
}

getData().then(function (data) {
  signData = data;
  submitBtn.disabled = false;
  loadWaiter.style.display = "none";
}).catch(function (err) {
  loadWaiter.innerHTML = "Lookup is temporarily unavailable. Please try again shortly.";
  console.error(err);
});

function isNumber(entry) {
  return entry[0] === lookupNumber;
}

function runLookup() {
  lookupNumber = lookupInput.value.trim();
  if (!lookupNumber || !signData) {
    return;
  }

  errorBox.style.display = "none";
  successBox.style.display = "none";

  var entryData = signData.values.find(isNumber);

  if (entryData == null) {
    errorBox.style.display = "block";
    return;
  }

  document.getElementById("SignID").innerHTML = entryData[0];
  document.getElementById("signer").innerHTML = entryData[2];
  document.getElementById("itemType").innerHTML = entryData[3];

  var notesRow = document.getElementById("notesRow");
  if (entryData[4] == null || entryData[4] === "") {
    notesRow.style.display = "none";
    document.getElementById("additionalNotes").innerHTML = "";
  } else {
    document.getElementById("additionalNotes").innerHTML = entryData[4];
    notesRow.style.display = "";
  }

  successBox.style.display = "block";
}

submitBtn.addEventListener("click", runLookup);

lookupInput.addEventListener("keypress", function (event) {
  if (event.key === "Enter") {
    event.preventDefault();
    runLookup();
  }
});


  } catch(e) { console.error(e); }
})();
})();
